import { Box, Stack, Typography } from '@mui/material';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { H5, Small } from '../../components/Typography';
import FlexBox from '../../components/flexbox/FlexBox';

const ProfileStatsCard = ({ data = [] }) => {
  const navigate = useNavigate();

  // Format number to display as "1k", "2k", etc. for numbers >= 1000
  const formatCount = count => {
    const numCount = Number(count);
    if (isNaN(numCount)) return count; // Return as-is if not a number
    if (numCount >= 1000) {
      const value = numCount / 1000;
      const formatted = value.toFixed(1);
      // Remove ".0" if present, otherwise keep the decimal
      return formatted.endsWith('.0')
        ? `${Math.floor(value)}k`
        : `${formatted}k`;
    }
    return count;
  };

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: '24px',
        padding: '20px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #f0f0f0',
      }}
    >
      <FlexBox
        onClick={() => navigate('/naver/callmetellme/mypage')}
        sx={{
          cursor: 'pointer',
          alignItems: 'center',
          paddingBottom: '16px',
        }}
      >
        <img
          src="/static/logo/logo-2.svg"
          alt="profile"
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            backgroundColor: '#4A90E2',
            marginRight: '8px',
            objectFit: 'contain',
          }}
        />
        <H5>홍길동</H5>
      </FlexBox>

      {/* Stats list */}
      <Stack spacing={1}>
        {data.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={() => navigate(item.path || '')}
          >
            <Small
              sx={{
                fontSize: '16px',
                color: '#333333',
                fontWeight: 500,
              }}
            >
              {item.text}
            </Small>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  fontSize: '18px',
                  fontWeight: 700,
                  color: item.count > 0 ? '#4A90E2' : '#999999',
                }}
              >
                {formatCount(item.count)}
              </Typography>
              <Box marginBottom={'-8px'}>
                <ChevronRight color={item.count > 0 ? '#4A90E2' : '#999999'} />
              </Box>
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default ProfileStatsCard;
